import { Tab } from "@headlessui/react";
import React, { FC, Fragment,useEffect,useState } from "react";
import {useHistory, useParams} from "react-router-dom";
import visaPng from "images/vis.png";
import mastercardPng from "images/mastercard.svg";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
import StartRating from "components/StartRating/StartRating";
import NcModal from "shared/NcModal/NcModal";
import moment from "moment";
import { DateRage } from "components/HeroSearchForm/StaySearchForm";
import { GuestsObject } from "components/HeroSearchForm2Mobile/GuestsInput";
import CardForm from "./CardForm";
import useAuth from "components/Authprovider/Auth";
import toast from "react-hot-toast";
import { fetchData } from "data/api/fetch";
import { HotelType, bookingType } from "data/types";



function diffDays(date1: string | undefined, date2: string | undefined): number {
  // Use the optional chaining operator to check if the parameters are null or undefined
  // Use the nullish coalescing operator to provide a default value of the current date
  // Convert the dates to moment objects using moment constructor
  const date_1 = moment(date1 ?? new Date());
  const date_2 = moment(date2 ?? new Date());
  // Use the diff method to get the difference in milliseconds
  let diff = date_1.diff(date_2,"days");
  // Return the absolute value of the difference in days
  return Math.abs(diff);
}


type typeParams = {
  id: any;
};
export interface CheckOutPageProps {
  className?: string;
}

const CheckOutPage: FC<CheckOutPageProps> = ({ className = "" }) => {
  const navigater = useHistory()

  const { id } = useParams<typeParams>();
  
  const {user,token} = useAuth()
  
  const [data,setData] = useState<HotelType>()
  const [booking,setBooking] = useState<bookingType>()

  

  //////////////////////////////////////////////////////////////////
  const headers = {
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  const getHotel = (id: number)=>{
    const getHotels = fetchData('https://phplaravel-930928-3230982.cloudwaysapps.com/api/hotel/'+id,{},headers)

    toast.promise(getHotels, {
      loading: "Loading booked hotel....",
      success: (data: any) => `Successful`,
      error: (error) => `Booked hotel not found`,
    });

    getHotels.then((data: any) => {
      // Use setData to update the state with the data
      setData(data.data)
    });

  }

  useEffect(()=>{
    console.log(id)
    const getBookings = fetchData('https://phplaravel-930928-3230982.cloudwaysapps.com/api/user/'+user?.id+'/bookings/'+id,{},headers)

    toast.promise(getBookings, {
      loading: "Loading booking....",
      success: (data: any) => `Successful`,
      error: (error) => `Unable to retrieve booking`,
    });

    getBookings.then((data: any) => {
      // Use setData to update the state with the data
      setBooking(data.booking)
      getHotel(data.booking.hotel_id)
      console.log(data)
    });
    
  },[id])


  /////////////////////////////////////////////////////////////
  const makePayment = async (token: string) => {

     console.log(token);

    const headers = {
      headers: { "Content-Type": "application/json"},
      method: "POST",
      body: JSON.stringify({ flexresponse: `${token}`, amount: booking?.total_price, currency: 'USD',clientReference: booking?.id})
    }

    const postData = () => {
      return fetch('https://nb-flex.onrender.com/pay', headers)
      .then((response) =>{
        if (response.status === 200 || response.status === 201) {
          // Parse the response as JSON and resolve the promise with the data
          return response.json();
        } else {
          // Reject the promise with an error message
          new Error(`Fetch failed: ${response.status} ${response.statusText}`);
        }
      })
      .then((result) => console.log(result));
    };

    const notify = () => {
      toast.promise(postData(), {
        loading: "Processing transaction...",
        success: (result) => `Transaction successfully`,
        error: (error) => `Something went wrong: ${error}`,
      });
    };

    notify()
      
  }


  const renderSidebar = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-shrink-0 w-full sm:w-40">
            <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
              <NcImage src={data?.image} />
            </div>
          </div>
          <div className="py-5 sm:px-5 space-y-3">
            <div>
              <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1">
                {data?.address}
              </span>
              <span className="text-base font-medium mt-1 block">
                {data?.name}
              </span>
            </div>
            <span className="block  text-sm text-neutral-500 dark:text-neutral-400">
              {data?.no_of_single_rooms} Single rooms · {data?.no_of_double_rooms} Double rooms · {data?.no_of_suite_rooms} Suites
            </span>
            <div className="w-10 border-b border-neutral-200  dark:border-neutral-700"></div>
            <StartRating point={data?.rating}/>
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold">Price detail</h3>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Room type</span>
            <span>{booking?.room_type}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Number of rooms</span>
            <span>{booking?.number_of_rooms || 0}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Number of guests</span>
            <span>{booking?.number_of_guests || 0}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Number of days</span>
            <span>{diffDays(booking?.check_in_date,booking?.check_out_date)}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Dialy price</span>
            <span>${booking?.daily_price || 0}</span>
          </div>
          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold">
            <span>Total</span>
            <span>${booking?.total_price || 0}</span>
          </div>
        </div>
      </div>
    );
  };

  const renderMain = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <h2 className="text-3xl lg:text-4xl font-semibold">
          Pay for your booking
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <div>
            {/*<h3 className="text-2xl font-semibold">Your booking</h3>*/}
            <NcModal
              renderTrigger={(openModal) => (
                <span
                  onClick={() => openModal()}
                  className="block lg:hidden underline  mt-1 cursor-pointer"
                >
                  View booking details
                </span>
              )}
              renderContent={renderSidebar}
              modalTitle="Booking details"
            />
          </div>
          <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
            
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-semibold">Pay with</h3>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-5"></div>

          <div className="mt-6">
            <Tab.Group>
              <Tab.List className="flex my-5">
                {/*<Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-full focus:outline-none ${
                        selected
                          ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900"
                          : "text-neutral-6000 dark:text-neutral-400"
                      }`}
                    >
                      Pay at premise
                    </button>
                  )}
                  </Tab>*/}
                <Tab as={Fragment}>
                  {({ selected }) => (
                    <button
                      className={`px-4 py-1.5 sm:px-6 sm:py-2.5  rounded-full flex items-center justify-center focus:outline-none  ${
                        selected
                          ? "bg-neutral-800 dark:bg-neutral-300 text-white dark:text-neutral-900"
                          : " text-neutral-6000 dark:text-neutral-400"
                      }`}
                    >
                      <span className="mr-2.5">Credit card</span>
                      <img className="w-8" src={visaPng} alt="" />
                      <img className="w-8" src={mastercardPng} alt="" />
                    </button>
                  )}
                </Tab>
              </Tab.List>

              <Tab.Panels>
              {/*<Tab.Panel className="space-y-5">
                  <div className="space-y-1">
                    <Label>Name </Label>
                    <Input type="email" defaultValue="" />
                    <span className="text-sm text-neutral-500 block">
                      This name will be used by hosts to register you.
                    </span>
                  </div>
                  <div className="space-y-1">
                    <Label>Number </Label>
                    <Input type="telephone" defaultValue="09" />
                    <span className="text-sm text-neutral-500 block">
                      Use a working telephone number for you to be contacted.
                    </span>
                  </div>
                  <div className="space-y-1">
                    <Label>Messager for host </Label>
                    <Textarea placeholder="..." />
                    <span className="text-sm text-neutral-500 block">
                      Write a few sentences on information host have to know beforehand.
                    </span>
                  </div>
                    </Tab.Panel>*/}

                <Tab.Panel className="space-y-5">
                  <CardForm captureContextUrl="https://nb-flex.onrender.com/checkout" onError={(e)=> console.log(e)} onToken={makePayment}/>
                </Tab.Panel>
                
              </Tab.Panels>
            </Tab.Group>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-CheckOutPage ${className}`} data-nc-id="CheckOutPage">
      {}
      <main className="container mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10 ">{renderMain()}</div>
        <div className="hidden lg:block flex-grow">{renderSidebar()}</div>
        {}
      </main>
    </div>
  );
};

export default CheckOutPage;
